import { defineComponent as _defineComponent } from 'vue'
import { useRirekishoPreview } from '@/composables/format-edit/useRirekishoPreview'
import hobbyOptions from '@/utils/format-edit/designRirekishoHobbyOptions.json'

type FormatPreviewSfcProps = {
  formatData: Record<string, any>
  basicData: Record<string, any>
  previewScale?: number
  currentCardId?: string | string[]
  idPrefix?: string
  isSample?: boolean
  formatId?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DesignRirekisho001PreviewDoc',
  props: {
    formatData: null,
    basicData: null,
    previewScale: { default: 1 },
    currentCardId: { default: '' },
    idPrefix: { default: '' },
    isSample: { type: Boolean, default: false },
    formatId: null
  },
  setup(__props: any, { expose }) {

const props = __props as { formatData: Record<string, any>, basicData: Record<string, any>, previewScale: number, currentCardId: string | string[], idPrefix: string, isSample: boolean, formatId?: string };



const {
  reason,
  mypr,
  checkValid,
  formLib,
  highlightMessage,
  goCardTo,
  highLightClass,
  classObject,
  tel
} = useRirekishoPreview(props, {
  maxEduJobRows: 22,
  maxLicenseRows: 6,
  textareaMaxHeights: { reason: 180, request: 180, mypr: 180 },
  overflowFields: ['reason', 'reasonNew', 'request', 'addressFurigana', 'mypr'],
  revalidateOnFormatDataChange: true
})

expose({ checkValid })

return { __sfc: true,props, reason, mypr, checkValid, formLib, highlightMessage, goCardTo, highLightClass, classObject, tel, hobbyOptions }
}

})